import "../styles/Footer.scss";
import { Link } from "react-router-dom";

import { AiFillInstagram, AiFillLinkedin, AiFillGithub } from "react-icons/ai"

import CLink from "./CLink";

export default function Footer(props) {


    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    <h3>Quick Links</h3>
                    <nav className="footer-nav">
                        <CLink to="/">Home</CLink>
                        <CLink to="/explore">Explore</CLink>
                        <CLink to="/contests">Contests</CLink>
                    </nav>
                    <div className="pillContainer">
                        <CLink 
                            to="https://statuspage.c0dify.xyz" 
                            className="systemStatusPill"
                            target="_blank"
                        >
                            <span className="circle green"></span>
                            <span className="text">
                                It's all good man!
                            </span>
                        </CLink>
                    </div>
                </div>
                
                <div className="footer-right">
                    <div className="footer-brand">
                        <h2>C0dify</h2>
                        <p>Code. Compete. Conquer.</p>
                        👋 <a href="mailto:hello@c0dify.xyz">hello@c0dify.xyz</a>
                    </div>
                    
                    <div className="footer-links">
                        <Link to="/terms">Terms & Conditions</Link>
                        <Link to="/privacy">Privacy Policy</Link>
                    </div>

                    <div className="footer-social">
                        <Link to={"https://github.com/c0difyhq"} target="_blank" rel="noopener noreferrer">
                            <AiFillGithub size={24} />
                        </Link>
                        {/* <AiFillLinkedin size={24} />
                        <AiFillInstagram size={24} /> */}
                    </div>
                </div>
            </div>
        </footer>
    )
}